import { cloneDeep } from 'lodash';

import { SerializableObject } from '../../../objects/generic/serialization/serializable-object';

export class RequestObj extends SerializableObject {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected idempotencyToken?: string;

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getIdempotencyToken() {
    return cloneDeep(this.idempotencyToken);
  }
}
